import React from 'react';
import { XMarkIcon, CheckCircleIcon, ExclamationTriangleIcon } from '@heroicons/react/24/outline';
import { useAlert } from '../context/AlertContext';

const Alert = () => {
    const { alerts, clearAlert } = useAlert();

    if (!alerts || alerts.length === 0) return null;

    const icons = {
        success: <CheckCircleIcon className="w-6 h-6" />,
        error: <ExclamationTriangleIcon className="w-6 h-6" />,
    };

    const alertClasses = {
        success: 'alert-success',
        error: 'alert-error',
    };

    return (
        <div className="space-y-2">
            {alerts.map(alert => (
                <div 
                    key={alert.id}
                    className={`alert ${alertClasses[alert.type]} mb-4`}
                >
                    {icons[alert.type]}
                    <span>{alert.message}</span>
                    <button 
                        onClick={() => clearAlert(alert.id)}
                        className="btn btn-ghost btn-sm"
                    >
                        <XMarkIcon className="w-4 h-4" />
                    </button>
                </div>
            ))}
        </div>
    );
};

export default Alert; 